import React, { ReactNode } from 'react';
import { saveSolPurchase } from './constants';

// ReactContext to simplify access of StripeOnramp object
const CryptoElementsContext = React.createContext(null);

export const CryptoElements = ({
  stripeOnramp,
  children,
}) => {
  const [ctx, setContext] = React.useState(() => ({ onramp: null }));

  React.useEffect(() => {
    let isMounted = true;

    Promise.resolve(stripeOnramp).then((onramp) => {
      if (onramp && isMounted) {
        setContext((ctx) => (ctx.onramp ? ctx : { onramp }));
      }
    });

    return () => {
      isMounted = false;
    };
  }, [stripeOnramp]);

  return (
    <CryptoElementsContext.Provider value={ctx}>
      {children}
    </CryptoElementsContext.Provider>
  );
};

// React hook to get StripeOnramp from context
export const useStripeOnramp = () => {
  const context = React.useContext(CryptoElementsContext);
  return context?.onramp;
};

// React element to render Onramp UI
export const OnrampElement = ({
  clientSecret, 
  ...props
}) => {
  const stripeOnramp = useStripeOnramp();
  const onrampElementRef = React.useRef(null);



  React.useEffect(() => {
    const containerRef = onrampElementRef.current;
    if (containerRef) {
      containerRef.innerHTML = '';

      if (clientSecret && stripeOnramp) {
        stripeOnramp
          .createSession({
            clientSecret,
            appearance: {
                theme: 'dark'
            },
          }).addEventListener('onramp_session_updated', (e) => {
            //showMessage(`OnrampSession is now in ${e.payload.session.status} state.`)
            //console.log(e.payload.session.status);
            if(e.payload.session.status === 'fulfillment_complete') {
              //alert("Payment is successful");

              //console.log(e.payload);
              props.showSuccessPayment();

              let cryptoAmount=  Number.parseFloat(e.payload.session.quote.destination_crypto_amount).toFixed(4);
              props.setMintErrorSub("You’ve paid $"+e.payload.session.quote.total_amount+" to add "+cryptoAmount+" SOL to your wallet.");

              saveSolPurchase(e.payload);
            }
          })
          .mount(containerRef)
      }
    }
  }, [clientSecret, stripeOnramp]);

  return <div {...props} ref={onrampElementRef}></div>;
};
